<template>
    <el-scrollbar class="news-detail-container" :native="false">
        <div class="news-detail">
            <div class="news-title">京东机器人 教育学院</div>
            <div class="news-content">
                <img src="../../assets/images/news/01.png" alt="">
                <img src="../../assets/images/news/02.png" alt="">
                <img src="../../assets/images/news/03.png" alt="">
                <img src="../../assets/images/news/04.png" alt="">
                <img src="../../assets/images/news/05.png" alt="">
                <img src="../../assets/images/news/06.png" alt="">
                <img src="../../assets/images/news/07.png" alt="">
                <img src="../../assets/images/news/08.png" alt="">
                <img src="../../assets/images/news/09.png" alt="">
                <img src="../../assets/images/news/10.png" alt="">
                <img src="../../assets/images/news/11.png" alt="">
                <img src="../../assets/images/news/12.png" alt="">
                <img src="../../assets/images/news/13.png" alt="">
                <img src="../../assets/images/news/14.png" alt="">
                <img src="../../assets/images/news/15.png" alt="">
                <img src="../../assets/images/news/16.png" alt="">
                <img src="../../assets/images/news/17.png" alt="">
                <img src="../../assets/images/news/18.png" alt="">
                <img src="../../assets/images/news/19.png" alt="">
                <img src="../../assets/images/news/20.png" alt="">
                <img src="../../assets/images/news/21.png" alt="">
                <img src="../../assets/images/news/22.png" alt="">
                <img src="../../assets/images/news/23.png" alt="">
                <img src="../../assets/images/news/24.png" alt="">
                <img src="../../assets/images/news/25.png" alt="">
                <img src="../../assets/images/news/26.png" alt="">
                <img src="../../assets/images/news/27.png" alt="">
                <img src="../../assets/images/news/28.png" alt="">
            </div>
        </div>
    </el-scrollbar>
</template>

<script>
    export default {
        data() {
            return {

            }
        }
    }
</script>

<style scoped lang="scss">
    .news-detail-container {
        background: #f2f2f2;
        width: 100%;
        height: 100%;
        overflow: hidden;
        ::v-deep .el-scrollbar__wrap {
            overflow-x: hidden;
        }
        .news-detail {
            width: 1100px;
            background: #fff;
            margin: 50px auto;
            box-shadow: 0 2px 10px 0 rgba(32,32,32,0.05);
            padding: 40px 50px;
            .news-title {
                text-align: center;
                font-size: 30px;
                color: #000;
                margin-bottom: 20px;
            }
            .news-content {
                p {
                    margin-top: 20px;
                    margin-bottom: 0;
                }
                img {
                    margin-top: 20px;
                    max-width: 100%;
                }
                h3 {
                    margin-bottom: 0;
                }
            }
        }
    }
</style>